// extracted by mini-css-extract-plugin
module.exports = {"buttonSpacer":"_36kcf84sM2qvsCyQRKZgNr"};